import React from 'react';
import { angular2react } from 'angular2react';
import {
  angularRouteViewComponent,
  externalAngularViewComponent,
} from '@app/angularRouteView';
// eslint-disable-next-line import/named
import { lazyInjector } from '@app/lazyInjector';
import {
  AgentsContext,
  AuthContext,
  ListingLabelContext,
  ContactDrawerContext,
  ExternalAuthContext,
  FeedbackModalContext,
  AppointmentActionModalContext,
  LayoutContext,
  UserFavoritesContext,
  OnboardingWelcomeModalContext,
} from 'contexts';
import AppTitleSelector from './AppTitleSelector';

const AngularRouteView: any = angular2react(
  'angularRouteView',
  angularRouteViewComponent,
  // @ts-ignore
  lazyInjector.$injector,
);

const ExternalAngularRouteView: any = angular2react(
  'externalAngularView',
  externalAngularViewComponent,
  // @ts-ignore
  lazyInjector.$injector,
);

const AngularPages: React.FC = () => {
  const { fetchOrgUsers } = React.useContext(AgentsContext);
  const { auth, orgStatus, orgPlan, pusher } = React.useContext(AuthContext);
  const { auth: extAuth, setAuth } = React.useContext(ExternalAuthContext);
  const { getBoardName, labelOverrideMap, getAvailability, getLabel } =
    React.useContext(ListingLabelContext);
  const { openContactDrawer } = React.useContext(ContactDrawerContext);
  const { setChatVisibility, isMobileView } = React.useContext(LayoutContext);
  const { favorites, toggleFavorite } = React.useContext(UserFavoritesContext);
  const { openModal: openFeedbackModal } =
    React.useContext(FeedbackModalContext);
  const { openModal: openAppointmentActionModal } = React.useContext(
    AppointmentActionModalContext,
  );
  const { isDoneWelcomeFlow } = React.useContext(OnboardingWelcomeModalContext);

  if ((!auth || !pusher) && !extAuth) return null;

  return (
    <div className="global--angular">
      <AppTitleSelector />
      {extAuth ? (
        <ExternalAngularRouteView
          key={extAuth?.listing?.id}
          reactExternalAuth={extAuth}
          labelOverrideMap={labelOverrideMap}
          getAvailability={getAvailability}
          getLabel={getLabel}
          getBoardName={getBoardName}
          setAuth={setAuth}
        />
      ) : (
        <AngularRouteView
          reactAuth={auth}
          labelOverrideMap={labelOverrideMap}
          getAvailability={getAvailability}
          getLabel={getLabel}
          getBoardName={getBoardName}
          pusher={pusher}
          openContactDrawer={openContactDrawer}
          fetchOrgUsers={fetchOrgUsers}
          setChatVisibility={setChatVisibility}
          isMobileView={isMobileView}
          favorites={favorites}
          orgStatus={orgStatus}
          currentPlan={orgPlan}
          toggleFavorite={toggleFavorite}
          openFeedbackModal={openFeedbackModal}
          openAppointmentActionModal={openAppointmentActionModal}
          isDoneWelcomeFlow={isDoneWelcomeFlow}
        />
      )}
    </div>
  );
};

export default AngularPages;
